import React from 'react';
import { useGameStore } from '../store/gameStore';

const LevelProgressBar: React.FC = () => {
  const { playerLevel, getLevelProgress, formatNumber } = useGameStore();
  
  // Funktion zum Öffnen der StatsOverlay (simuliert Klick auf den Stats-Button)
  const openStatsOverlay = () => {
    const statsButton = document.querySelector('[title="📊 Detaillierte Statistiken"]') as HTMLButtonElement;
    if (statsButton) {
      statsButton.click();
    }
  };

  const { currentXP, nextLevelXP, progress } = getLevelProgress();
  const progressPercentage = Math.min(progress * 100, 100);

  return (
    <>
      <div className="w-full bg-gray-900/90 backdrop-blur-sm border-b border-gray-700 relative z-20">
        <div className="relative h-3 bg-gray-800">
          {/* Fortschrittsbalken */}
          <div 
            className="h-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transition-all duration-300 ease-out"
            style={{ width: `${progressPercentage}%` }}
          >
            {/* Glanz-Effekt */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse"></div>
          </div>
          
          {/* Level-Info */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-xs font-bold text-white drop-shadow-lg">
              Level {formatNumber(playerLevel)} • {formatNumber(currentXP)} / {formatNumber(nextLevelXP)} XP
            </div>
          </div>
          
          {/* Fortschritts-Prozent rechts */}
          <div className="absolute right-2 top-0 h-full flex items-center">
            <span className="text-xs font-semibold text-white drop-shadow-lg">
              {progressPercentage.toFixed(1)}%
            </span>
          </div>
          
          {/* Klickbarer Level-Badge links */}
          <div className="absolute left-2 top-0 h-full flex items-center">
            <button
              onClick={openStatsOverlay}
              className="bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-black text-xs font-bold px-2 py-0.5 rounded-full shadow-lg transition-all duration-200 transform hover:scale-105 active:scale-95 touch-manipulation"
              title="📊 Vollständige detaillierte Statistiken anzeigen"
            >
              Lv. {formatNumber(playerLevel)}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LevelProgressBar; 